import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var GapClass;
function Gap() {
  if (GapClass === VOID) {
    class $ {
      constructor(start, offsetBefore, offsetAfter) {
        this.start_1 = start;
        this.offsetBefore_1 = offsetBefore;
        this.offsetAfter_1 = offsetAfter;
        // Inline function 'kotlin.check' call
        if (!(this.offsetBefore_1.totalSeconds_1 < this.offsetAfter_1.totalSeconds_1)) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Check failed.');
        }
      }
      get_transitionDurationSeconds_pn5o5p_k$() {
        return this.offsetAfter_1.totalSeconds_1 - this.offsetBefore_1.totalSeconds_1 | 0;
      }
      toString() {
        return 'Gap(start=' + this.start_1.toString() + ', offsetBefore=' + this.offsetBefore_1.toString() + ', offsetAfter=' + this.offsetAfter_1.toString() + ')';
      }
      hashCode() {
        var result = this.start_1.hashCode();
        result = imul(result, 31) + this.offsetBefore_1.hashCode() | 0;
        result = imul(result, 31) + this.offsetAfter_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Gap()))
          return false;
        var tmp0_other_with_cast = other instanceof Gap() ? other : THROW_CCE();
        if (!this.start_1.equals(tmp0_other_with_cast.start_1))
          return false;
        if (!this.offsetBefore_1.equals(tmp0_other_with_cast.offsetBefore_1))
          return false;
        if (!this.offsetAfter_1.equals(tmp0_other_with_cast.offsetAfter_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Gap');
    GapClass = $;
  }
  return GapClass;
}
var OverlapClass;
function Overlap() {
  if (OverlapClass === VOID) {
    class $ {
      constructor(start, offsetBefore, offsetAfter) {
        this.start_1 = start;
        this.offsetBefore_1 = offsetBefore;
        this.offsetAfter_1 = offsetAfter;
        // Inline function 'kotlin.check' call
        if (!(this.offsetBefore_1.totalSeconds_1 > this.offsetAfter_1.totalSeconds_1)) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Check failed.');
        }
      }
      toString() {
        return 'Overlap(start=' + this.start_1.toString() + ', offsetBefore=' + this.offsetBefore_1.toString() + ', offsetAfter=' + this.offsetAfter_1.toString() + ')';
      }
      hashCode() {
        var result = this.start_1.hashCode();
        result = imul(result, 31) + this.offsetBefore_1.hashCode() | 0;
        result = imul(result, 31) + this.offsetAfter_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Overlap()))
          return false;
        var tmp0_other_with_cast = other instanceof Overlap() ? other : THROW_CCE();
        if (!this.start_1.equals(tmp0_other_with_cast.start_1))
          return false;
        if (!this.offsetBefore_1.equals(tmp0_other_with_cast.offsetBefore_1))
          return false;
        if (!this.offsetAfter_1.equals(tmp0_other_with_cast.offsetAfter_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Overlap');
    OverlapClass = $;
  }
  return OverlapClass;
}
var RegularClass;
function Regular() {
  if (RegularClass === VOID) {
    class $ {
      constructor(offset) {
        this.offset_1 = offset;
      }
      toString() {
        return 'Regular(offset=' + this.offset_1.toString() + ')';
      }
      hashCode() {
        return this.offset_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Regular()))
          return false;
        var tmp0_other_with_cast = other instanceof Regular() ? other : THROW_CCE();
        if (!this.offset_1.equals(tmp0_other_with_cast.offset_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Regular');
    RegularClass = $;
  }
  return RegularClass;
}
function OffsetInfo(transitionInstant, offsetBefore, offsetAfter) {
  var tmp;
  if (offsetBefore.equals(offsetAfter)) {
    tmp = new (Regular())(offsetBefore);
  } else if (offsetBefore.totalSeconds_1 < offsetAfter.totalSeconds_1) {
    tmp = new (Gap())(transitionInstant, offsetBefore, offsetAfter);
  } else {
    tmp = new (Overlap())(transitionInstant, offsetBefore, offsetAfter);
  }
  return tmp;
}
//region block: exports
export {
  Gap as Gapiqt6nuekag60,
  Overlap as Overlap7zq5geu1d3zf,
  Regular as Regular3ayyei7bjphdz,
  OffsetInfo as OffsetInfo3e2qnmrj9hm5p,
};
//endregion

//# sourceMappingURL=OffsetInfo.mjs.map
